import React from "react";

export const Diagnosis05: React.FC = () => {
  return (
    <div className="diagnosis05-section">
      <div className="moreinfo-container">
        <div className="moreinfo-content">
          <div className="moreinfo-left">
            <p className="moreinfo-text">
              En el caso de llegar a pasar por una laparoscopía, en las citas previas a ella, pídele a tu médico que te 
              saque fotos o te grabe videos cortos del procedimiento.
            </p>
            
            <p className="moreinfo-text">
              No es algo de lo que mucha gente tenga conocimiento, pero al igual que con cualquier otro estudio o procedimiento, 
              es tu derecho que te den las imágenes.
            </p>
            
            <p className="moreinfo-text">
              Tenerlas puede ayudarte para en un futuro repasar la cirugía con tu médico para poder sacarte todas las eventuales 
              dudas que puedas tener o incluso para hacer consultas con otros especialistas.
            </p>
          </div>
          
          <div className="moreinfo-right">
            <div className="moreinfo-image-container">
              <img
                src="img/diagnosis11.png"
                className="moreinfo-image"
                alt="Registro de procedimientos"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};